var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n\t\t\t补卡申请-" + _vm._s(_vm.ruleForm.id === null || _vm.ruleForm.id === '' ? '新增' : '修改'))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "overflow-x": "hidden"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    on: {
      "click": _vm.StaffFind
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "80px",
      "width": "80%"
    },
    attrs: {
      "label": "补卡人",
      "prop": "staff_id"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "595px"
    },
    attrs: {
      "onfocus": "this.blur();"
    },
    model: {
      value: (_vm.ruleForm.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "staff_name", $$v)
      },
      expression: "ruleForm.staff_name"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "补卡时间",
      "prop": "replacement_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "595px"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value-format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.replacement_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "replacement_date", $$v)
      },
      expression: "ruleForm.replacement_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "补卡原因",
      "prop": "replacement_reason"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "595px"
    },
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入代岗原因"
    },
    model: {
      value: (_vm.ruleForm.replacement_reason),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "replacement_reason", $$v)
      },
      expression: "ruleForm.replacement_reason"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "图片",
      "prop": "replacement_url"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "limit": 1,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handleAvatarSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.ruleForm.replacement_url,
      "alt": ""
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "200px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id === null || _vm.ruleForm.id === ''),
      expression: "ruleForm.id === null || ruleForm.id === ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.AddAuditor()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.UpdateAuditor()
      }
    }
  }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择补卡人",
      "visible": _vm.dialogVisible,
      "width": "40%",
      "center": true,
      "close-on-click-modal": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('organizeStaff', {
    ref: "organizeStaff",
    attrs: {
      "type": "radio",
      "accordion": false,
      "staff_id_prop": _vm.ruleForm.staff_id
    },
    on: {
      "commit": _vm.saveChange
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['organizeStaff'].commit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择审核人",
      "visible": _vm.dialogAuditorVisible,
      "width": "40%",
      "center": true,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogAuditorVisible = $event
      }
    }
  }, [_c('SelectAuditor', {
    ref: "SelectAuditor",
    attrs: {
      "type": 8,
      "examineDetailsList": _vm.ruleForm.examineDetailsList,
      "id": _vm.ruleForm.id
    }
  })], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-087377ce","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Bksq/Bksq_add.vue
// module id = null
// module chunks = 